import { openBlock as l, createElementBlock as c, normalizeStyle as f, toDisplayString as m, createCommentVNode as w, createElementVNode as d, Fragment as y, renderList as h, normalizeClass as b } from "vue";
import { _ as g } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/PollForm.css';const A = {
  props: {
    interaction: {
      type: Object,
      require: !0
    },
    isQuerySuccess: {
      type: Boolean,
      require: !1,
      default: !0
    }
  },
  emits: ["chooseAnswer"],
  data() {
    return {
      answerNumber: void 0,
      isAlreadyAnswered: !1
    };
  },
  created() {
    this.interaction.polls.forEach((s, t) => {
      s.isSelected && (this.answerNumber = t, this.isAlreadyAnswered = !0);
    });
  },
  computed: {
    isAnswered() {
      return this.answerNumber !== void 0;
    },
    countOfVoites() {
      let s = 0;
      return this.interaction.polls.forEach((t) => {
        s += t.count;
      }), s;
    },
    isShowPercentage() {
      return this.isAnswered && (this.isQuerySuccess || this.isAlreadyAnswered);
    }
  },
  methods: {
    handleClick(s, t) {
      this.answerNumber = t, this.$emit("chooseAnswer", { index: t, ...s });
    },
    checkOnHasEmoji(s) {
      return /([^\u0020-\u2116])/gu.test(s);
    },
    getListOfDividingTextAndEmoji(s) {
      const t = [];
      if (this.checkOnHasEmoji(s)) {
        const i = s.match(/./gu);
        let _ = 0, r = 1, e = !1, n = !1;
        i.forEach((u, a) => {
          if (e = this.checkOnHasEmoji(u), a === 0 && (n = e), n !== e) {
            const p = i.slice(_, r).join("");
            t.push({
              text: p,
              isEmoji: e
            }), _ = a;
          } else
            r = a + 1;
        });
        const o = i.slice(_, r).join("");
        t.push({
          text: o,
          isEmoji: e
        });
      } else
        t.push({
          text: s,
          isEmoji: !1
        });
      return t;
    }
  }
}, E = { class: "frisbuy-poll" }, j = { class: "frisbuy-poll__body" }, k = ["disabled", "onClick"], v = { class: "frisbuy-poll__question-text" }, O = { class: "frisbuy-poll__question-text-wrapper" };
function S(s, t, i, _, r, e) {
  return l(), c("div", E, [
    i.interaction.caption ? (l(), c("div", {
      key: 0,
      class: "frisbuy-poll__header",
      style: f({ backgroundColor: i.interaction.backgroundColor })
    }, m(i.interaction.caption), 5)) : w("", !0),
    d("div", j, [
      (l(!0), c(y, null, h(i.interaction.polls, (n, o) => (l(), c("button", {
        class: b(["frisbuy-poll__question", {
          "frisbuy-poll__question--disabled": e.isAnswered,
          "frisbuy-poll__question--selected": r.answerNumber === o,
          "frisbuy-poll__question--waiting": e.isAnswered && !i.isQuerySuccess && !r.isAlreadyAnswered && r.answerNumber === o
        }]),
        key: o,
        disabled: e.isAnswered,
        onClick: (u) => e.handleClick(n, o)
      }, [
        d("div", v, [
          d("div", {
            class: "frisbuy-poll__question-progress",
            style: f({
              width: `${e.isAnswered && (i.isQuerySuccess || r.isAlreadyAnswered) ? Math.round(n.count / e.countOfVoites * 100) : 0}%`
            })
          }, null, 4),
          d("span", O, [
            (l(!0), c(y, null, h(e.getListOfDividingTextAndEmoji(
              n.title
            ), (u, a) => (l(), c("span", {
              key: a,
              class: b(["frisbuy-poll__question-text-input", { "frisbuy-poll__question-text--emoji": u.isEmoji }])
            }, m(u.text), 3))), 128))
          ]),
          d("div", {
            style: f({ opacity: Number(e.isShowPercentage) }),
            class: "frisbuy-poll__question-percentage"
          }, m(e.isShowPercentage ? Math.round(n.count / e.countOfVoites * 100) : "?") + "% ", 5)
        ])
      ], 10, k))), 128))
    ])
  ]);
}
const C = /* @__PURE__ */ g(A, [["render", S], ["__scopeId", "data-v-9a903039"]]);
export {
  C as default
};
